export const HypertensionEnum = {
  label: 'Hipertensão',
  id: 1,
}

export const DiabeticEnum = {
  label: 'Diabetes',
  id: 2,
}

export const DislipidemicEnum = {
  label: 'Dislipidemia',
  id: 3,
}

export const ObesityEnum = {
  label: 'Sobrepeso',
  id: 4,
}

export const HealthyEnum = {
  label: 'Sem comorbidades',
  id: 5,
}

export const NotCollectedEnum = {
  label: 'Não coletado',
  id: 6,
}

export const RisksEnum = {
  HypertensionEnum,
  DiabeticEnum,
  DislipidemicEnum,
  ObesityEnum,
  HealthyEnum,
  NotCollectedEnum,
}
